import React from "react";

/** Ícones Lucide no tamanho do Example_layout (18px). */
export const createSideNavIcon = (LucideIcon) => {
	const SideNavIcon = (props) => (
		<LucideIcon size={18} strokeWidth={2} aria-hidden {...props} />
	);
	return SideNavIcon;
};
